import { Maybe, Model, Product, ProductProperties } from 'src/types';
import { CurrentCampaign, RouteSection } from '../../types';

export interface IProductPageTabsProps extends IProductTabMainProps {
  routeSection: RouteSection;
}

export interface IProductTabMainProps {
  product: Product & Maybe<{ coreProperties: ProductProperties }>;
  recommendations?: Maybe<Model[]>;
  trendingProducts: Product['trendingProducts'];
  currentCampaign: CurrentCampaign;
}

export enum TabAnchor {
  ALL = '#all',
  PROPERTIES = '#properties',
  REVIEWS = '#reviews',
  STATISTICS = '#statistics',
}
